import Keycloak from 'keycloak-js'

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = new Keycloak({ clientId: import.meta.env.VITE_CLIENT_ID, realm: window.location.pathname.split('/')[1], url: import.meta.env.VITE_KEYCLOAK_BASE_URL })

export default keycloak